import { useState } from 'react';
import { faqs } from '@/mocks/faqs';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-16 md:py-20 bg-background-100" aria-labelledby="faq-heading">
      <script
        type="application/ld+json"
        data-dynamic-ld="true"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 id="faq-heading" className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">
            关于文爱社区，你可能想了解的一切
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => toggle(idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors duration-200"
                aria-expanded={openIndex === idx}
              >
                <span className="text-sm font-medium text-foreground-800 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-400 w-5 h-5 flex items-center justify-center transition-transform duration-300 ${
                    openIndex === idx ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-4 text-sm text-foreground-500 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}